// extracted by mini-css-extract-plugin
export default {"input":"ReportSearch-module_input__1uOqT"};